import { type ConversationResult, conversationResultSchema } from '@/schemas/commons';

import type { AlertSeverity } from './Conversations.types';

export const PAGE_SIZE = 12;

/**
 * Severity tier per alert key, used to pick the chip colour.
 *
 * Deliberately a lookup with a fallback rather than an exhaustive union: the
 * backend derives alerts at read time and can add one without a frontend
 * release (back#SPEC-007 adds `reported`). An unmapped alert renders in the
 * low tier with its raw key instead of disappearing from a column someone is
 * triaging with.
 */
export const ALERT_SEVERITY: Record<string, AlertSeverity> = {
	graph_error: 'high',
	prompt_injection: 'high',
	frustration: 'mid',
	judge_failed: 'mid',
	llm_escalation: 'mid',
	p9_scrub: 'low',
};

export const DEFAULT_ALERT_SEVERITY: AlertSeverity = 'low';

/** ISO-2 codes of the countries AgendaPro operates in. */
export const COUNTRY_OPTIONS = ['CL', 'MX', 'AR', 'CO', 'PE', 'UY'];

export const CHANNEL_OPTIONS = ['Intercom', 'WhatsApp', 'Email'];

export const PERIOD_OPTIONS = ['today', '7d', '30d'];

export const STATUS_OPTIONS = ['active', 'handoff', 'closed', 'tool_error'];

/** How the conversation ended, from the per-turn decision behind the Intercom tags. */
export const RESULT_OPTIONS: ConversationResult[] = [...conversationResultSchema.options];

/**
 * The nine domains the RAG supervisor classifies a query into. Listed here so
 * the filter offers every area up front — a dropdown built from the current
 * page would hide the areas the operator is looking for precisely because no
 * conversation on screen has them.
 */
export const AREA_OPTIONS = [
	'agenda',
	'cuenta_suscripcion_cobranza',
	'cobros_cliente_final',
	'facturacion_boletas_negocio',
	'clientes_fichas_datos',
	'comunicaciones_growth',
	'reportes_caja_backoffice',
	'soporte_tecnico_integraciones',
	'agendapro_fitness',
];

/** Same reasoning as `AREA_OPTIONS`: the full set, not what the page happens to show. */
export const ALERT_OPTIONS = [
	'graph_error',
	'llm_escalation',
	'frustration',
	'prompt_injection',
	'judge_failed',
	'p9_scrub',
];
